<template>
    <div class="card">
        <div class="d-flex flex-column my-2">

            <div class="ms-2 mb-2">
                <strong>Components</strong>
            </div>

            <Container key="componentOptions" behaviour="copy" group-name="componentOptions"
                       :get-child-payload="getCurrentComponent">
                <Draggable v-for="componentType in availableComponents" :key="componentType">

                    <li class="list-group-item draggable-item pointer">
                        <div class="d-flex justify-content-center align-items-center">
                            <i class="me-2 mt-1 text-primary" :class="getComponentClass(componentType)"> </i>
                            <div class="mt-1">{{componentType}}</div>
                            <i class="fa fa-ellipsis-v drag-icon ms-auto" aria-hidden="true"></i>
                        </div>
                    </li>
                </Draggable>
            </Container>

        </div>

        <div v-if="model.app.id && layoutType !== 'header' && availableViews.length > 0" class="d-flex flex-column my-2">

            <div class="ms-2 mb-2">
                <strong>Views</strong>
            </div>

            <Container key="availableViewOptions" behaviour="copy" group-name="availableViewOptions"
                       :get-child-payload="getAvailableView">
                <Draggable v-for="availableView in availableViews" :key="availableView.id + 'AvailableView'">

                    <li class="list-group-item draggable-item pointer">

                        <div class="d-flex justify-content-center align-items-center">
                            <i class="me-2 mt-1 text-primary fad fa-browser" style="color: #cccccc"></i>
                            <div class="mt-1">{{availableView.name}}</div>
                            <i class="fa fa-ellipsis-v drag-icon ms-auto" aria-hidden="true"></i>
                        </div>

                    </li>
                </Draggable>
            </Container>

        </div>

    </div>
</template>

<script>
    import {Container, Draggable} from "vue3-smooth-dnd"
    import PageFactory from "../../utils/PageFactory";

    export default {
        name: 'ElementSelector',
        props: ['layout', 'layoutType'],
        components: {
            Container,
            Draggable
        },
        computed: {
            availableViews() {
                return webase.managers.app.getViews()
            },
            availableComponents() {

                if(this.layoutType === 'header') {
                    return [
                        'Label', 'Icon', 'Link', 'Image', 'Button'
                    ]
                }

                return this.model.componentTypes
            }
        },
        data() {
            return {
                model: webase.model,
                factory: new PageFactory()
            }
        },
        methods: {
            getCurrentComponent(index) {
                let componentType = this.availableComponents[index]

                if(componentType === 'Button') {
                    return this.getButton(componentType)
                }
                else if(componentType === 'Link') {
                    return this.factory.createLink('New Link')
                }
                else if(componentType === 'Header') {
                    return this.factory.createHeaderComponent('New Header')
                }
                else if(componentType === 'Video') {
                    return this.factory.createVideoComponent()
                }
                else if(componentType === 'Container') {
                    let rowContainer =  this.factory.createRowContainer()
                    let label = this.factory.createHtmlComponent('Label', 'New Label')
                    rowContainer.value.push(label)
                    return rowContainer
                }
                else if(componentType === 'Row') {
                    let internalRow =  this.factory.createRow()
                    internalRow.type = 'InternalRow'
                    internalRow.parentColumn = null
                    let labelColumn = this.factory.createLabelColumn('12', 'New Embedded Row')
                    internalRow.columns.push(labelColumn)
                    // let label = this.factory.createHtmlComponent('Label', 'New Label')
                    // rowContainer.value.push(label)
                    return internalRow
                }

                return this.factory.createHtmlComponent(componentType, 'New ' + componentType)
            },
            getButton(buttonType) {
                return this.factory.createButton('New ' +  buttonType)
            },
            getClass(field) {
                return webase.utils.ui.getClass(field)
            },
            getComponentClass(componentType) {
                return webase.utils.ui.getComponentClass(componentType)
            },
            getAvailableView(index) {
                let view = this.availableViews[index]

                let payload = {
                    type: 'View',
                    value: view.id,
                    showHeader: true
                }

                return payload
            }
        }
    }
</script>